export const FETCH_START = 'palmetto/FETCH_START'
export const FETCH_SUCCESS = 'palmetto/FETCH_SUCCESS'
export const FETCH_FAILURE = 'palmetto/FETCH_FAILURE'

export const FETCH_PALMETTO_INCIDENTS_START =
  'palmetto/FETCH_PALMETTO_INCIDENTS_START'
export const FETCH_PALMETTO_INCIDENTS_SUCCESS =
  'palmetto/FETCH_PALMETTO_INCIDENTS_SUCCESS'
export const FETCH_PALMETTO_INCIDENTS_FAILURE =
  'palmetto/FETCH_PALMETTO_INCIDENTS_FAILURE'

export const FETCH_EVENT_TYPES_START = 'palmetto/FETCH_EVENT_TYPES_START'
export const FETCH_EVENT_TYPES_SUCCESS = 'palmetto/FETCH_EVENT_TYPES_SUCCESS'
export const FETCH_EVENT_TYPES_FAILURE = 'palmetto/FETCH_EVENT_TYPES_FAILURE'

export const SELECT_INCIDENTS = 'palmetto/SELECT_INCIDENTS'
export const NEXT_INCIDENT = 'palmetto/NEXT_INCIDENT'
export const PREV_INCIDENT = 'palmetto/PREV_INCIDENT'
export const CLEAR_SELECTION = 'palmetto/CLEAR_SELECTION'

export const HOVER = 'palmetto/HOVER'
export const END_HOVER = 'palmetto/END_HOVER'

export const OPEN_FORM = 'palmetto/OPEN_FORM'
export const CLOSE_FORM = 'palmetto/CLOSE_FORM'
export const SET_TITLE = 'palmetto/SET_TITLE'
export const SET_INCIDENT = 'palmetto/SET_INCIDENT'
export const SET_EVENT_TYPE = 'palmetto/SET_EVENT_TYPE'
export const SEND_TO_PALMETTO = 'palmetto/SEND_TO_PALMETTO'
